import { useTranslation } from "react-i18next";

const Catalog = () => {
  const { t } = useTranslation();

  return (
    <div className="flex items-center justify-center min-h-[60vh]">
      <div className="text-center">
        <h1 className="text-3xl font-bold text-gray-900 mb-4">
          {t("admin.catalog.title", "Catalog")}
        </h1>
        <p className="text-lg text-gray-600">
          {t("admin.catalog.upcomingFeature", "This is an upcoming feature")}
        </p>
      </div>
    </div>
  );
};

export default Catalog;
